import { useEffect, useRef } from 'react'
import { track } from '../services/analytics'
import apiInterviewVersions from '../services/api/interviewVersion'
import { decodeInterviewToken } from '../utilities/tokenUtils'

const TYPE_LABELS = {
  VIDEO: 'Video',
  COVERLETTER: 'Cover Letter',
  TEXT: 'Text',
  INPERSON: 'In-Person',
  FORM: 'Form',
}

export const startInterviewEvent = (interviewType) =>
  `Start ${TYPE_LABELS[interviewType] || 'Video'} Interview`

export const RESCHEDULED_FLOW_KEY = 'rescheduledFlow'

const isRescheduledFlow = () => {
  try {
    return localStorage.getItem(RESCHEDULED_FLOW_KEY) === 'true'
  } catch {
    return false
  }
}

const decode = (rawJWT) => {
  try {
    return decodeInterviewToken(rawJWT) || {}
  } catch {
    return {}
  }
}

export default function useInterviewTracking(
  rawJWT,
  interviewType,
  { trackEntry = false } = {},
) {
  const propertiesRef = useRef({})

  useEffect(() => {
    if (!rawJWT) return undefined
    let cancelled = false
    const payload = decode(rawJWT)

    Promise.all([
      apiInterviewVersions.startInterview(rawJWT).catch(() => null),
      apiInterviewVersions
        .getNumberOfQuestionsByInterview(rawJWT)
        .catch(() => null),
    ]).then(([interview, questions]) => {
      if (cancelled) return
      propertiesRef.current = {
        company_name: interview?.company?.company_name,
        position_id: payload.position_id,
        user_id: payload.candidate_id,
        interview_type: interview?.type,
        number_of_questions: questions?.questions,
      }
      if (trackEntry)
        track('Pick a time', {
          position_id: payload.position_id,
          user_id: payload.candidate_id,
          date: new Date().toISOString(),
        })
    })

    return () => {
      cancelled = true
    }
  }, [rawJWT])

  return (event, extraProperties) => {
    const rescheduled = isRescheduledFlow()
    track(
      event,
      {
        ...propertiesRef.current,
        interview_type: interviewType || propertiesRef.current.interview_type,
        ...(rescheduled && { rescheduled: true }),
        ...extraProperties,
      },
      { transport: 'sendBeacon', send_immediately: true },
    )
    if (event === 'Finish Interview')
      localStorage.removeItem(RESCHEDULED_FLOW_KEY)
  }
}
